export default "__VITE_ASSET__1acdaf59__"